import { addMonths } from 'date-fns';

import { formatIsoLocalDateTime } from '@townsquare/date-utils/format';
import { getUtcEndOfGoalMonth, parseGoalUpdatesFeedStartDate } from '@townsquare/date-utils/update';
import { RelayResourceConfig, createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';

import GoalUpdatesViewQuery, {
	type GoalUpdatesViewQuery as GoalUpdatesViewQueryType,
} from '../GoalUpdatesView/__generated__/GoalUpdatesViewQuery.graphql';
import { getUpdateStateFilterFromQueryParams } from '../components/UpdateStateFilter';

export const goalUpdatesResource = createRelayResource<GoalUpdatesViewQueryType>({
	getQuery: (routerContext, resourceContext): RelayResourceConfig<GoalUpdatesViewQueryType> => {
		const context = resourceContext as ResourceContext;
		const utcStartDate = parseGoalUpdatesFeedStartDate(routerContext.query.start);
		const utcPrevDate = addMonths(utcStartDate, -1);
		const utcEndDate = getUtcEndOfGoalMonth(utcStartDate);

		return {
			query: GoalUpdatesViewQuery,
			variables: {
				workspaceId: context.workspace?.globalId || '',
				prevDate: formatIsoLocalDateTime(utcPrevDate),
				startDate: formatIsoLocalDateTime(utcStartDate),
				endDate: formatIsoLocalDateTime(utcEndDate),
				stateFilter: getUpdateStateFilterFromQueryParams(routerContext.query.filter),
			},
			cacheKey: 'goalUpdates',
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
